// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';   // 一定要 import Tailwind 的 CSS
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
